// Auto-split from i18n.js — language: en
export default {
    translation: {
        // routes & menus
        Dashboard: 'Dashboard',
        'Space Data': 'Space',
        'Equipment Data': 'Equipment',
        'Meter Data': 'Meter',
        'Tenant Data': 'Tenant',
        'Store Data': 'Store',
        'Shopfloor Data': 'Shopfloor',
        'Combined Equipment Data': 'Combined Equipment',
        'Auxiliary System': 'Auxiliary System',
        Microgrid: 'Microgrid',
        'Energy Storage Power Station': 'Power Station',
        'Photovoltaic Power Station': 'Power Station',
        'Fault Alarm': 'Fault Alarm',
        Monitoring: 'Monitoring',
        'Advanced Reporting': 'Advanced Reporting',
        'Knowledge Base': 'Knowledge Base',
        'Energy Category Data': 'Energy Category',
        'Energy Item Data': 'Energy Item',
        Carbon: 'CO2 Emissions',
        Cost: 'Cost',
        Output: 'Output',
        Income: 'Income',
        Efficiency: 'Efficiency',
        Load: 'Load',
        Statistics: 'Statistics',
        'Batch Analysis': 'Batch Analysis',
        Saving: 'SavingⒺ',
        Plan: 'PlanⒺ',
        Prediction: 'PredictionⒺ',
        'Production': 'Production',
        'Space Production': 'Space Production',
        'Equipment Tracking': 'Equipment Tracking',
        'Equipment Comparison': 'Comparison',
        'Shopfloor Comparison': 'Comparison',
        'Store Comparison': 'Comparison',
        'Space Comparison': 'Comparison',
        'Combined Equipment Comparison': 'Comparison',
        'Tenant Comparison': 'Comparison',
        'Environment Monitor': 'Environment Monitor',
        'Meter Energy': 'Meter Energy',
        'Meter Prediction': 'Meter PredictionⒺ',
        'Virtual Meter Prediction': 'Virtual Meter PredictionⒺ',
        'Offline Meter Prediction': 'Offline Meter PredictionⒺ',
        'Meter Carbon': 'Meter CO2 Emissions',
        'Meter Cost': 'Meter Cost',
        'Meter Trend': 'Meter Trend',
        'Meter Realtime': 'Meter Realtime',
        'Meter Saving': 'Meter SavingⒺ',
        'Meter Plan': 'Meter PlanⒺ',
        'Master Meter Submeters Balance': 'Master Meter Submeters Balance',
        'Meter Batch Analysis': 'Meter Batch Analysis',
        'Meter Comparison': 'Meter Comparison',
        'Meter Tracking': 'Meter Tracking',
        'Virtual Meter Saving': 'Virtual Meter SavingⒺ',
        'Virtual Meter Plan': 'Virtual Meter PlanⒺ',
        'Virtual Meter Energy': 'Virtual Meter Energy',
        'Virtual Meter Carbon': 'Virtual Meter CO2 Emissions',
        'Virtual Meter Cost': 'Virtual Meter Cost',
        'Virtual Meter Batch Analysis': 'Virtual Meter Batch Analysis',
        'Virtual Meter Comparison': 'Virtual Meter Comparison',
        'Offline Meter Energy': 'Offline Meter Energy',
        'Offline Meter Carbon': 'Offline Meter CO2 Emissions',
        'Offline Meter Cost': 'Offline Meter Cost',
        'Offline Meter Batch Analysis': 'Offline Meter Batch Analysis',
        'Offline Meter Saving': 'Offline Meter SavingⒺ',
        'Offline Meter Plan': 'Offline Meter PlanⒺ',
        'Offline Meter Input': 'Offline Meter Input',
        'Tenant Bill': 'Tenant Bill',
        'Energy Flow Diagram': 'Energy Flow Diagram',
        'Distribution System': 'Distribution System',
        'SVG System': 'SCADA Visualization System',
        'Faults Data': 'Faults',
        'Space Equipments': 'Space Equipments',
        'Combined Equipments': 'Combined Equipments',
        'Energy Storage Power Station List': 'List',
        'Energy Storage Power Station Details': 'Details',
        'Energy Storage Power Station Reporting': 'Reporting',
        'Energy Storage Power Station Alarm': 'Alarm',
        'Energy Storage Power Station Maintenance': 'Maintenance',
        'Enter Production': 'Enter Production',
        'Multiple Microgrids': 'Multiple Microgirds',
        'Multiple Microgrids Dashboard': 'Dashboard',
        'Multiple Microgrids List': 'List',
        'Single Microgrid': 'Single Microgrid',
        'Single Microgrid Dashboard': 'Dashboard',
        'Single Microgrid Details': 'Details',
        'Single Microgrid Fault Alarm': 'Fault Alarm',
        'Microgrid Reports': 'Power Station Reports',
        'Microgrid Reports Energy': 'Energy',
        'Microgrid Reports Revenue': 'Revenue',
        'Microgrid Reports Parameters': 'Parameters',
        'Multiple Energy Storage Power Stations': 'Multiple Power Stations',
        'Multiple Energy Storage Power Stations Dashboard': 'Dashboard',
        'Multiple Energy Storage Power Stations List': 'List',
        'Single Energy Storage Power Station': 'Single Power Station',
        'Single Energy Storage Power Station Dashboard': 'Dashboard',
        'Single Energy Storage Power Station Details': 'Details',
        'Single Energy Storage Power Station Fault Alarm': 'Fault Alarm',
        'Energy Storage Power Station Reports': 'Power Station Reports',
        'Energy Storage Power Station Reports Energy': 'Energy',
        'Energy Storage Power Station Reports Revenue': 'Revenue',
        'Energy Storage Power Station Reports Parameters': 'Parameters',
        'Photovoltaic Power Station List': 'Power Station List',
        'Photovoltaic Power Station Details': 'Details',
        'Photovoltaic Power Station Reporting': 'Reporting',
        'Photovoltaic Power Station Alarm': 'Alarm',
        'Photovoltaic Power Station Maintenance': 'Maintenance',
        'Multiple Photovoltaic Power Stations': 'Multiple Power Stations',
        'Multiple Photovoltaic Power Stations Dashboard': 'Dashboard',
        'Multiple Photovoltaic Power Stations List': 'List',
        'Single Photovoltaic Power Station': 'Single Power Station',
        'Single Photovoltaic Power Station Dashboard': 'Dashboard',
        'Single Photovoltaic Power Station Details': 'Details',
        'Single Photovoltaic Power Station Fault Alarm': 'Fault Alarm',
        'Photovoltaic Power Station Reports': 'Power Station Reports',
        'Photovoltaic Power Station Reports Energy': 'Energy',
        'Photovoltaic Power Station Reports Revenue': 'Revenue',
        'Photovoltaic Power Station Reports Parameters': 'Parameters',
        'Work Order': 'Work Order',
        'Work Order Installation': 'Installation',
        'Work Order Repair': ' Repair',
        'Work Order Inspection': 'Inspection',
        'Total Number of Work Orders': 'Total Number of Work Orders',
        'Number of New Work Orders': 'Number of New Work Orders',
        'Number of Inprogress Work Orders': 'Number of Inprogress Work Orders',
        'Number of Done Work Orders': 'Number of Done Work Orders',
        'Fuel Indicator': 'Fuel Consumption',
        'Charge Energy Indicator': 'Charge Energy',
        'Discharge Energy Indicator': 'Disharge Energy',
        'Charge Cost Indicator': 'Charge Cost',
        'Discharge Revenue Indicator': 'Discharge Revenue',
        'HVAC': 'HVAC',
        'Fire Control': 'Fire Control',
        // Tenant Dashboard
        'Tenant Dashboard': 'Tenant Dashboard',
        'Comprehensive overview of tenant energy performance': 'Comprehensive overview of tenant energy performance',
        'Total Tenants': 'Total Tenants',
        'Tenant Performance Overview': 'Tenant Performance Overview',
        'Tenant Name': 'Tenant Name',
        'Tenant Area': 'Tenant Area',
        'Tenant Type': 'Tenant Type',
        // Equipment Dashboard
        'Equipment Dashboard': 'Equipment Dashboard',
        'Total Equipments': 'Total Equipments',
        'Equipment Performance Overview': 'Equipment Performance Overview',
        'Equipment Name': 'Equipment Name',
        'Equipment Type': 'Equipment Type',
        'Total Energy': 'Total Energy',
        'Total Sensors': 'Total Sensors',
        'Increment Rate': 'Increment Rate',

        // Store Dashboard
        'Store Dashboard': 'Store Dashboard',
        'Comprehensive overview of store energy performance': 'Comprehensive overview of store energy performance',
        'Total Stores': 'Total Stores',
        'Total Area': 'Total Area',
        'Active Meters': 'Active Meters',
        'Active Alerts': 'Active Alerts',
        'Total Energy Consumption': 'Total Energy Consumption',
        'Total Cost': 'Total Cost',
        'Carbon Emissions': 'Carbon Emissions',
        'Current Period': 'Current Period',
        'Energy Consumption by Category': 'Energy Consumption by Category',
        'Cost Distribution by Category': 'Cost Distribution by Category',
        'Monthly Energy & Cost Trends': 'Monthly Energy & Cost Trends',
        'Top 5 Energy Consuming Stores': 'Top 5 Energy Consuming Stores',
        'Energy Category Details': 'Energy Category Details',
        'Store Performance Overview': 'Store Performance Overview',
        'YoY Change': 'YoY Change',
        'Per m²': 'Per m²',
        'Usage Intensity': 'Usage Intensity',
        'Dashboard data loaded successfully': 'Dashboard data loaded successfully',
        'Failed to load dashboard data': 'Failed to load dashboard data',
        'Store Name': 'Store Name',
        'Store Area': 'Store Area',
        'Energy Consumption': 'Energy Consumption',
        'Consumption': 'Consumption',
        'last period': 'last period',


        // Shopfloor Dashboard
        'Total Shopfloors': 'Total Shopfloors',
        'Shopfloor Performance Overview': 'Shopfloor Performance Overview',
        'Shopfloor Name': 'Shopfloor Name',
        'Shopfloor Area': 'Shopfloor Area',

        // Combined Equipment Dashboard
        'Total Combined Equipments': 'Total Combined Equipments',
        'Combined Equipment Performance Overview': 'Combined Equipment Performance Overview',
        'Combined Equipment Name': 'Combined Equipment Name',
        'Associated Equipments': 'Associated Equipments',
        // Dashboard
        'Welcome to QiXuan': 'Welcome to QiXuan',
        'An Industry Leading Energy Management System': 'An Industry Leading Energy Management System',
        "This Year's Consumption CATEGORY VALUE UNIT": "This Year's Consumption {{CATEGORY}} {{VALUE}} {{UNIT}}",
        "This Year's Costs CATEGORY VALUE UNIT": "This Year's Costs {{CATEGORY}} {{VALUE}} {{UNIT}}",
        "This Month's Consumption CATEGORY VALUE UNIT": "This Month's Consumption {{CATEGORY}} {{VALUE}} {{UNIT}}",
        "This Month's Generation CATEGORY VALUE UNIT": "This Month's Generation {{CATEGORY}} {{VALUE}} {{UNIT}}",
        "This Month's Costs CATEGORY VALUE UNIT": "This Month's Costs {{CATEGORY}} {{VALUE}} {{UNIT}}",
        'Consumption CATEGORY VALUE UNIT in The Same Period Last Year':
            'Consumption {{CATEGORY}} {{VALUE}} {{UNIT}}  in The Same Period Last Year',
        'Costs CATEGORY VALUE UNIT in The Same Period Last Year':
            'Costs {{CATEGORY}} {{VALUE}} {{UNIT}} in The Same Period Last Year',
        'CATEGORY Consumption UNIT': '{{CATEGORY}} Consumption {{UNIT}}',
        'CATEGORY Costs UNIT': '{{CATEGORY}} Costs {{UNIT}}',
        // Entities
        Space: 'Space',
        Equipment: 'Equipment',
        Meter: 'Meter',
        'Offline Meter': 'Offline Meter',
        'Virtual Meter': 'Virtual Meter',
        Tenant: 'Tenant',
        Store: 'Store',
        Shopfloor: 'Shopfloor',
        'Combined Equipment': 'Combined Equipment',
        'Cost Center': 'Cost Center',
        Name: 'Name',
        DisplayName: 'Display Name',
        UserName: 'User Name',
        Description: 'Description',
        'Energy Category': 'Energy Category',
        'Child Spaces': 'Child Spaces',
        'Associated Equipment': 'Associated Equipment',
        //Energy Categories
        Electricity: 'Electricity',
        Water: 'Water',
        'Natural Gas': 'Natural Gas',
        // SidePanelModal
        Settings: 'Settings',
        'Set your own customized style': 'Set your own customized style',
        'Color Scheme': 'Color Scheme',
        'Choose the perfect color mode for your app': 'Choose the perfect color mode for your app',
        Light: 'Light',
        Dark: 'Dark',
        'RTL Mode': 'RTL Mode',
        'Switch your language direction': 'Switch your language direction',
        'Fluid Layout': 'Fluid Layout',
        'Toggle container layout system': 'Toggle container layout system',
        'Navigation Position': 'Navigation Position',
        'Vertical': 'Vertical',
        'Top': 'Top',
        'Combo': 'Combo',
        'Transparent': 'Transparent',
        'Inverted': 'Inverted',
        'Card': 'Card',
        'Vibrant': 'Vibrant',
        'Select a suitable navigation system for your web application': 'Select a suitable navigation system for your web application',
        'Vertical Nav': 'Vertical Nav',
        'Top Nav': 'Top Nav',
        'Vertical Navbar Style': 'Vertical Navbar Style',
        'Switch between styles for your vertical navbar': 'Switch between styles for your vertical navbar',
        Language: 'Language',
        'Switch between languages': 'Switch between languages',
        'language-zh_CN': '简体中文',
        'language-en': 'English',
        'language-de': 'Deutsch',
        'language-fr': 'Français',
        'language-es': 'Español',
        'language-ru': 'Русский',
        'language-ar': 'العربية',
        'language-vi': 'Tiếng Việt',
        'language-th': 'ภาษาไทย',
        'language-tr': 'Türkçe',
        'language-ms': 'Bahasa Melayu',
        'language-id': 'Bahasa Indonesia',
        'language-zh_TW': '繁體中文',
        'language-pt': 'Português',
        'language-ko_KR': '로그아웃',
        'language-it': 'Italiano',
        'language-pol': 'Polski',
        'language-nl': 'Nederlands',
        'language-jp': '日本語',
        'language-fa': 'فارسی',
        'Like What You See?': 'Like What You See?',
        'Get QiXuan now': 'Get QiXuan now',
        'PQ.About': 'This analysis covers voltage deviation, voltage unbalance, frequency deviation, and current unbalance. Voltage deviation is computed as (U - Un) / Un × 100%; frequency deviation as |f - fn|; three-phase unbalance as max(|Xi - Xavg|) / Xavg × 100% using time-aligned phases. Results are calculated from the selected meter time-series within the chosen reporting period. If three-phase channels are not available or timestamps are not aligned, unbalance indices are skipped. Transient spikes or missing samples may inflate worst-case indicators; use compliance rate and P95 metrics to assess steady-state performance.',
        Purchase: 'Enterprise Edition',
        ContactInfo: 'Contact Information',
        ProductWebsite: 'Product Website',
        CompanyWebsite: 'Company Website',
        SalesPhone: 'Sales Phone',
        // Query Panel
        'Base Period Begins': 'Base Period Begins',
        'Base Period Ends': 'Base Period Ends',
        'Comparison Types': 'Comparison Types',
        'Year-Over-Year': 'Year-Over-Year',
        'Month-On-Month': 'Month-On-Month',
        'Free Comparison': 'Free Comparison',
        'None Comparison': 'None Comparison',
        'Reporting Period Begins': 'Reporting Period Begins',
        'Reporting Period Ends': 'Reporting Period Ends',
        '(Optional)': '(Optional)',
        'Period Types': 'Period Types',
        Yearly: 'Yearly',
        Monthly: 'Monthly',
        Weekly: 'Weekly',
        Daily: 'Daily',
        Hourly: 'Hourly',
        Submit: 'Submit',
        'Input Energy Category': 'Input Energy Category',
        'Output Energy Category': 'Output Energy Category',
        'Fraction Parameter': 'Fraction Parameter',
        Search: 'Search',
        //DateRangePicker
        sunday: 'Su',
        monday: 'Mo',
        tuesday: 'Tu',
        wednesday: 'We',
        thursday: 'Th',
        friday: 'Fr',
        saturday: 'Sa',
        ok: 'OK',
        today: 'Today',
        yesterday: 'Yesterday',
        hours: 'Hours',
        minutes: 'Minutes',
        seconds: 'Seconds',
        last7Days: 'Last 7 Days',
        tomorrow: 'Tomorrow',
        dayAfterTomorrow: 'Day After Tomorrow',
        next7Days: 'Next 7 Days',
        'Select Date Range': 'Select Date Range',
        //Card Summaries and Line Charts
        'Base Period': 'Base Period',
        'Reporting Period': 'Reporting Period',
        'Per Unit Area': 'Per Unit Area',
        'Per Capita': 'Per Capita',
        'Per Unit Production': 'Per Unit Production',
        Baseline: 'Baseline',
        Actual: 'Actual',
        'Baseline Value - Actual Value': 'Baseline - Actual',
        'Average Load': 'Average Load',
        'Maximum Load': 'Maximum Load',
        'Load Factor': 'Load Factor',
        'Ratio of Average Load to Maximum Load': 'Ratio of Average Load to Maximum Load',
        'Carbon Dioxide Emissions by Energy Category': 'Carbon Dioxide Emissions by Energy Category',
        'Costs by Energy Category': 'Costs by Energy Category',
        'Incomes by Energy Category': 'Incomes by Energy Category',
        'Electricity Consumption by Time-Of-Use': 'Electricity Consumption by Time-Of-Use',
        'Electricity Carbon Dioxide Emissions by Time-Of-Use': 'Electricity Carbon Dioxide Emissions by Time-Of-Use',
        'Electricity Cost by Time-Of-Use': 'Electricity Cost by Time-Of-Use',
        'CATEGORY UNIT Consumption by Energy Items': '{{CATEGORY}} {{UNIT}} Comsumption by Energy Items',
        'Ton of Standard Coal by Energy Category': 'Ton of Standard Coal(TCE) by Energy Category',
        'Ton of Carbon Dioxide Emissions by Energy Category': 'Ton of Carbon Dioxide Emissions(TCO2E) by Energy Category',
        'Reporting Period Consumption CATEGORY UNIT': 'Reporting Period Consumption {{CATEGORY}} {{UNIT}}',
        'Reporting Period Prediction CATEGORY UNIT': 'Reporting Period Prediction {{CATEGORY}} {{UNIT}}',
        'EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
            '{{EQUIPMENT}} Reporting Period Consumption {{CATEGORY}} {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
            '{{COMBINED_EQUIPMENT}} Reporting Period Consumption {{CATEGORY}} {{UNIT}}',
        'CATEGORY VALUE UNIT': '{{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Consumption CATEGORY VALUE UNIT': 'Reporting Period Consumption {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Prediction CATEGORY VALUE UNIT': 'Reporting Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Production PRODUCT VALUE UNIT': 'Reporting Period Production {{PRODUCT}} {{VALUE}} {{UNIT}}',
        'Base Period Consumption CATEGORY VALUE UNIT': 'Base Period Consumption {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Prediction CATEGORY VALUE UNIT': 'Base Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Production PRODUCT VALUE UNIT': 'Base Period Production {{PRODUCT}} {{VALUE}} {{UNIT}}',
        'Reporting Period Consumption ITEM CATEGORY UNIT': 'Reporting Period Consumption {{ITEM}} {{CATEGORY}} {{UNIT}}',
        'Reporting Period Consumption ITEM CATEGORY VALUE UNIT':
            'Reporting Period Consumption {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Consumption ITEM CATEGORY VALUE UNIT':
            'Base Period Consumption {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Child Space Proportion CATEGORY UNIT': 'Child Space Proportion by Energy Category {{CATEGORY}} {{UNIT}}',
        'Child Space Total Proportion': 'Child Space Total Proportion',
        'Reporting Period Carbon Dioxide Emissions CATEGORY UNIT':
            'Reporting Period Carbon Dioxide Emissions {{CATEGORY}} {{UNIT}}',
        'Reporting Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
            'Reporting Period Carbon Dioxide Emissions {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
            'Base Period Carbon Dioxide Emissions {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Costs CATEGORY UNIT': 'Reporting Period Costs {{CATEGORY}} {{UNIT}}',
        'Reporting Period Costs CATEGORY VALUE UNIT': 'Reporting Period Costs {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Costs CATEGORY VALUE UNIT': 'Base Period Costs {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Output CATEGORY UNIT': 'Reporting Period Output {{CATEGORY}} {{UNIT}}',
        'EQUIPMENT Reporting Period Output CATEGORY UNIT': '{{EQUIPMENT}} Reporting Period Output {{CATEGORY}} {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Output CATEGORY UNIT':
            '{{COMBINED_EQUIPMENT}} Reporting Period Output {{CATEGORY}} {{UNIT}}',
        'Reporting Period Output CATEGORY VALUE UNIT': 'Reporting Period Output {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Output CATEGORY VALUE UNIT': 'Base Period Output {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Income CATEGORY UNIT': 'Reporting Period Income {{CATEGORY}} {{UNIT}}',
        'Reporting Period Income CATEGORY VALUE UNIT': 'Reporting Period Income {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Income CATEGORY VALUE UNIT': 'Base Period Income {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Total Income UNIT': 'Reporting Period Total Income {{UNIT}}',
        'Reporting Period Cumulative Efficiency NAME UNIT': 'Reporting Period Cumulative Efficiency {{NAME}} {{UNIT}}',
        'EQUIPMENT Reporting Period Cumulative Efficiency UNIT':
            '{{EQUIPMENT}} Reporting Period Cumulative Efficiency {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency UNIT':
            '{{COMBINED_EQUIPMENT}} Reporting Period Cumulative Comprehensive Efficiency {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency VALUE UNIT':
            '{{COMBINED_EQUIPMENT}} Reporting Period Cumulative Comprehensive Efficiency {{VALUE}} {{UNIT}}',
        'COMBINED_EQUIPMENT Base Period Cumulative Comprehensive Efficiency VALUE UNIT':
            '{{COMBINED_EQUIPMENT}} Base Period Cumulative Comprehensive Efficiency {{VALUE}} {{UNIT}}',
        'Instantaneous Efficiency UNIT': 'Instantaneous Efficiency {{UNIT}}',
        'EQUIPMENT Instantaneous Efficiency UNIT': '{{EQUIPMENT}} Instantaneous Efficiency {{UNIT}}',
        'Equipment Efficiency Indicator': 'Equipment Efficiency Indicator',
        'COMBINED_EQUIPMENT Instantaneous Comprehensive Efficiency UNIT':
            '{{COMBINED_EQUIPMENT}} Instantaneous Comprehensive Efficiency {{UNIT}}',
        'Reporting Period Cumulative Efficiency VALUE UNIT': 'Reporting Period Cumulative Efficiency {{VALUE}} {{UNIT}}',
        'Reporting Period Cumulative Efficiency NAME VALUE UNIT':
            'Reporting Period Cumulative Efficiency {{NAME}} {{VALUE}} {{UNIT}}',
        'Base Period Cumulative Efficiency VALUE UNIT': 'Base Period Cumulative Efficiency {{VALUE}} {{UNIT}}',
        'Base Period Cumulative Efficiency NAME VALUE UNIT':
            'Base Period Cumulative Efficiency {{NAME}} {{VALUE}} {{UNIT}}',
        'Base Period CATEGORY Maximum Load UNIT': 'Base Period {{CATEGORY}} Maximum Load {{UNIT}}',
        'Reporting Period CATEGORY Maximum Load UNIT': 'Reporting Period {{CATEGORY}} Maximum Load {{UNIT}}',
        'Reporting Period CATEGORY Average Load UNIT': 'Reporting Period {{CATEGORY}} Average Load {{UNIT}}',
        'Reporting Period CATEGORY Load Factor': 'Reporting Period {{CATEGORY}} Load Factor',
        'Base Period CATEGORY Average Load VALUE UNIT': 'Base Period {{CATEGORY}} Average Load {{VALUE}} {{UNIT}}',
        'Reporting Period CATEGORY Average UNIT': 'Reporting Period {{CATEGORY}} Average Value {{UNIT}}',
        'Reporting Period CATEGORY Maximum UNIT': 'Reporting Period {{CATEGORY}} Maximum Value {{UNIT}}',
        'Reporting Period CATEGORY Minimum UNIT': 'Reporting Period {{CATEGORY}} Minimum Value {{UNIT}}',
        'Reporting Period CATEGORY Mean UNIT': 'Reporting Period {{CATEGORY}} Arithmetic Mean {{UNIT}}',
        'Reporting Period CATEGORY Median UNIT': 'Reporting Period {{CATEGORY}} Median (Middle Value) {{UNIT}}',
        'Reporting Period CATEGORY Stdev UNIT': 'Reporting Period {{CATEGORY}} Sample Standard Deviation {{UNIT}}',
        'Reporting Period CATEGORY Variance UNIT': 'Reporting Period {{CATEGORY}} Sample Variance {{UNIT}}',
        'Reporting Period Saving CATEGORY (Baseline - Actual) UNIT':
            'Reporting Period Saving {{CATEGORY}} (Baseline - Actual) {{UNIT}}',
        'Reporting Period Decreased CATEGORY (Baseline - Actual) UNIT':
            'Reporting Period Decreased {{CATEGORY}} (Baseline - Actual) {{UNIT}}',
        'Reporting Period Saving CATEGORY VALUE UNIT': 'Reporting Period Saving {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Saving CATEGORY VALUE UNIT': 'Base Period Saving {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Master Meter Consumption CATEGORY UNIT':
            'Reporting Period Master Meter Consumption {{CATEGORY}} {{UNIT}}',
        'Reporting Period Master Meter Consumption CATEGORY VALUE UNIT':
            'Reporting Period Master Meter Consumption {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Submeters Consumption CATEGORY UNIT':
            'Reporting Period Submeters Consumption {{CATEGORY}} {{UNIT}}',
        'Reporting Period Submeters Consumption CATEGORY VALUE UNIT':
            'Reporting Period Submeters Consumption {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Difference CATEGORY UNIT': 'Reporting Period Difference {{CATEGORY}} {{UNIT}}',
        'Reporting Period Percentage Difference': 'Reporting Period Percentage Difference',
        'Reporting Period Difference CATEGORY VALUE UNIT': 'Reporting Period Difference {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Trend Values': 'Trend Values',
        'METER CATEGORY VALUE UNIT': '{{METER}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'EQUIPMENT CATEGORY VALUE UNIT': '{{EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'COMBINED_EQUIPMENT CATEGORY VALUE UNIT': '{{COMBINED_EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'SHOPFLOOR CATEGORY VALUE UNIT': '{{SHOPFLOOR}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'TENANT CATEGORY VALUE UNIT': '{{TENANT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        //FDD
        'Fault List': 'Fault List',
        'Reporting Period Number of Fault VALUE': 'Reporting Period Number of Fault {{VALUE}}',
        'All Faults': 'All Faults',
        'Space Faults': 'Space Faults',
        'Number of All Faults': 'Number of All Faults',
        'Number of Space Faults': 'Number of Space Faults',
        'Total Number of Faults': 'Total Number of Faults',
        'Number of New Faults': 'Number of New Faults',
        'Number of Inprogress Faults': 'Number of Inprogress Faults',
        'Number of Done Faults': 'Number of Done Faults',
        //Data Panels
        'Ton of Standard Coal': 'Ton of Standard Coal',
        'Ton of Carbon Dioxide Emissions': 'Ton of Carbon Dioxide Emissions',
        'Carbon Emissions Per Unit Of Energy Consumption': 'Carbon emissions per unit of energy consumption',
        'Operating Characteristic Curve': 'Operating Characteristic Curve',
        Tariff: 'Tariff',
        'Detailed Data': 'Detailed Data',
        'Child Spaces Data': 'Child Spaces Data',
        'Associated Equipment Data': 'Associated Equipment Data',
        'This Year': 'This Year',
        'The Same Period Last Year': 'The Same Period Last Year',
        'This Month': 'This Month',
        'This Day': 'This Day',
        Total: 'Total',
        'No data found': 'No data found',
        Export: 'Export',
        'AI Analysis': 'AI Analysis',
        'AI analysis initial prompt':
            'Based only on the JSON report context below, summarize key findings, anomalies, and comparisons, then give energy-saving and O&M recommendations. Reply in plain text only (no Markdown). Use paragraphs and optional numbering.',
        'AI analysis loading': 'AI is analyzing report data…',
        'AI analysis follow up placeholder':
            'Ask a follow-up question about this report (optional)',
        Send: 'Send',
        'AI analysis copy': 'Copy',
        'AI analysis copied': 'Copied to clipboard',
        'AI analysis copy failed': 'Could not copy',
        'AI analysis max messages hint':
            'Maximum conversation length reached (5 messages per session).',
        Datetime: 'Datetime',
        'Time-Of-Use Type': 'Time-Of-Use Type',
        'Top-Peak': 'Top-Peak',
        'On-Peak': 'On-Peak',
        'Mid-Peak': 'Mid-Peak',
        'Off-Peak': 'Off-Peak',
        'Deep': 'Deep-Valley',
        Percentage: 'Percentage',
        //Realtime Chart
        'Trend in the last hour of Energy Value Point': 'Trend in the last hour of Energy Value Point',
        Circuit: 'Circuit',
        Point: 'Point',
        'Realtime Value': 'Realtime Value',
        //Meter Tracking
        'Meter List': 'Meter List',
        'Edit Meter': 'Edit',
        'Start Value': 'Start Value',
        'End Value': 'End Value',
        'Difference Value': 'Difference Value',
        'Start Integrity Rate': 'Start Integrity Rate(%)',
        'End Integrity Rate': 'End Integrity Rate(%)',
        'Full Integrity Rate': 'Full Integrity Rate(%)',
        'Start Integrity Rate Description': 'Start Data Integrity Rate: The proportion of all meters that successfully obtained energy consumption readings at the start time within the statistical period',
        'End Integrity Rate Description': 'End Data Integrity Rate: The proportion of all meters that successfully obtained energy consumption readings at the end time within the statistical period',
        'Full Integrity Rate Description': 'Full Data Integrity Rate: The proportion of all meters that successfully obtained energy consumption readings at both the start and end times within the statistical period',
        //Equipment Tracking
        'Equipment List': 'Equipment List',
        'Edit Equipment': 'Edit',
        //Profile Dropdown
        Feedback: 'Feedback',
        'Account Settings': 'Account Settings',
        Logout: 'Logout',
        //Authentication
        'Log in': 'Log in',
        'Email address': 'Email address',
        'Phone Number': 'Phone Number',
        Password: 'Password',
        CaptchaCode: 'Captcha',
        Refresh: 'Refresh',
        'Remember me': 'Remember me',
        'Logged in as ': 'Logged in as ',
        'Forgot Password?': 'Forgot Password?',
        'Forgot your password?': 'Forgot your password?',
        "Enter your email and we'll send you a reset link": "Enter your email and we'll send you a reset link",
        "Enter your email and we'll send you a registration link":
            "Enter your email and we'll send you a registration link",
        'Reset Password': 'Reset Password',
        'Thanks for using QiXuan!': 'Thanks for using QiXuan!',
        'You are now successfully signed out': 'You are now successfully signed out',
        'Return to Login': 'Return to Login',
        'Please check your email!': 'Please check your email!',
        'An email has been sent to ': 'An email has been sent to ',
        'Please click on the included link to reset your password':
            'Please click on the included link to reset your password',
        'Please click on the included link to register your account':
            'Please click on the included link to register your account',
        'An email with password reset link is sent to ': 'An email with password reset link is sent to ',
        'Change Password': 'Change Password',
        'Old Password': 'Old Password',
        'New Password': 'New Password',
        'Confirm Password': 'Confirm Password',
        'Update Password': 'Update Password',
        'Password has been changed!': 'Password has been changed!',
        'Verification code has been sent to your inbox. \
  Please copy it to the input box below..':
            'Verification code has been sent to your inbox. \
  Please copy it to the input box below.',
        'New to QiXuan': 'New to QiXuan',
        'Create an account': 'Create an account',
        'EMAIL Account registration successful': '{{EMAIL}} Account registration successful',
        'Thanks for verifying your account!': 'Thanks for verifying your account!',
        'Your code is': 'Your code is',
        'Send verification code': 'Send verification code',
        'Please wait for NUMBER seconds': 'Please wait for {{NUMBER}} seconds',
        'Password reset': 'Password reset',
        'Please wait for approval': 'Please wait for approval',
        //notification
        Notifications: 'Notifications',
        'Mark all as read': 'Mark all as read',
        'View all': 'All',
        'Notification New': 'NEW',
        'Notification Earlier': 'EARLIER',
        'Notification List': 'Notification List',
        'Bulk actions': 'Bulk actions',
        'Notification Subject': 'Subject',
        'Notification Created Datetime': 'Created Datetime',
        'Notification Priority': 'Priority',
        'Notification Message': 'Message',
        'Notification Status': 'Status',
        'Notification Mark As Read': 'Mark As Read',
        'Notification Mark As Acknowledged': 'Acknowledge',
        'Notification Low': 'Low',
        'Notification Medium': 'Medium',
        'Notification High': 'High',
        'Notification Critical': 'Critical',
        'Notification Unread': 'Unread',
        'Notification Read': 'Read',
        'Notification Acknowledged': 'Acknowledged',
        'Notification Archive': 'Archive',
        'Notification Delete': 'Delete',
        'Notification Apply': 'Apply',
        'Notification Start Datetime': 'Start Datetime',
        'Notification End Datetime': 'End Datetime',
        'Notification Update Datetime': 'Update Datetime',
        //Monitoring
        'Run Commands': 'Run Commands',
        'Pin Code': 'Pin Code',
        'Unlock': 'Unlock',
        'Set Value': 'Set Value',
        'Fault Alarms': 'Fault Alarms',
        'Instantaneous Efficiency VALUE UNIT': 'Instantaneous Efficiency {{VALUE}} {{UNIT}}',
        'Communication Online': 'Online',
        'Communication Offline': 'Offline',
        'Equipment Status': 'Equipment Status',
        'Equipment Running': 'Running',
        'Equipment Stopped': 'Stopped',
        'Show Up to': 'Show Up to',
        All: 'All',
        'FROM - TO of TOTAL': 'The current display of {{FROM}} - {{TO}} total {{TOTAL}}',
        //Microgrid
        'Microgrid Energy': 'Microgrid Energy',
        'Microgrid Revenue': 'Microgrid Revenue',
        'Microgrid Carbon': 'Microgrid Carbon',
        'Photovoltaic Generation': 'Photovoltaic Generation',
        'EV Charger Consumption': 'EV Charger Consumption',
        'Load Consumption': 'Load Consumption',
        'Grid Buy': 'Grid Buy',
        'Grid Sell': 'Grid Sell',
        'EV Charger': 'EV Charger',
        'Heat Pump': 'Heat Pump',
        'Photovoltaic': 'Photovoltaic',
        'PCS Run State': 'PCS Run State',
        'PCS Unknown': 'Unknown',
        'PCS Initializing': 'Initializing',
        'PCS Standby': 'Standby',
        'PCS Shutdown': 'Shutdown',
        'PCS Fault': 'Fault',
        'PCS Running': 'Running',
        'Battery Power': 'Battery Power',
        'Photovoltaic Power': 'Photovoltaic Power',
        'Grid Power': 'Grid Power',
        'Load Power': 'Load Power',
        Reporting: 'Reporting',
        Maintenance: 'Maintenance',
        'Serial Number': 'Serial Number',
        Address: 'Address',
        'Postal Code': 'Postal Code',
        'Rated Capacity': 'Rated Capacity',
        'Rated Power': 'Rated Power',
        Latitude: 'Latitude',
        Longitude: 'Longitude',
        'Strategy Management': 'Strategy Management',
        'Charging Schedule': 'Charging Schedule',
        'Charge Start Time': 'Charge Start Time',
        'Charge End Time': 'Charge End Time',
        'Discharge Start Time': 'Discharge Start Time',
        'Discharge End Time': 'Discharge End Time',
        'Total Rated Power': 'Total Rated Power',
        'Total Rated Capacity': 'Total Rated Capacity',
        "Today's Charge": "Today's Charge",
        "Today's Discharge": "Today's Discharge",
        "Today's Generation": "Today's Generation",
        'Total Fuel Consumption': 'Total Fuel Consumption',
        'Total Charge': 'Total Charge',
        'Total Discharge': 'Total Discharge',
        'Total Generation': 'Total Generation',
        'Total Revenue': 'Total Revenue',
        'Total Photovoltaic Generation': 'Total Photovoltaic Generation',
        'Total EV Charger Consumption': 'Total EV Charger Consumption',
        'Total Load Consumption': 'Total Load Consumption',
        'Total Grid Buy': 'Total Grid Buy',
        'Total Grid Sell': 'Total Grid Sell',
        'Total Efficiency': 'Total Efficiency',
        'Discharge Achievement Rate': 'Discharge Achievement Rate',
        'Revenue Ranking': 'Revenue Ranking',
        'Efficiency Ranking': 'Efficiency Ranking',
        'Charge Ranking': 'Charge Ranking',
        'Discharge Ranking': 'Discharge Ranking',
        'Number of Microgrids': 'Number of Microgrids',
        'Number of Power Stations': 'Number of Power Stations',
        'Microgrid List': 'Microgrid List',
        'Select Microgrid': 'Select Microgrid',
        'Previous Page': 'Previous Page',
        'Next Page': 'Next Page',
        '7 Days': '7 Days',
        'Charge UNIT': 'Charge {{UNIT}}',
        'Discharge UNIT': 'Discharge {{UNIT}}',
        'Generation UNIT': 'Generation {{UNIT}}',
        'Energy Indicator': 'Energy',
        'Revenue Indicator': 'Revenue',
        'Carbon Indicator': 'Carbon',

        // Energy Storage Power Station
        'Battery Operating State': 'Battery Operating State',
        'Battery State': 'Battery State',
        'Battery Unknown': 'Unknown',
        'Battery Stopped': 'Stopped',
        'Battery Reserved': 'Reserved', // 0
        'Battery Fault': 'Fault', // 1
        'Battery Warning': 'Warning', // 2
        'Battery Standby': 'Standby', // 3
        'Battery Prohibit DisCharging': 'Prohibit DisCharging', //4
        'Battery Prohibit Charging': 'Prohibit Charging',// 5
        'Battery Normal': 'Normal', // 6
        'Battery Charging': 'Charging', // 7
        'Battery Discharging': 'Discharging', // 8
        'Battery Idle': 'Idle', // 9
        'Phase of Lifecycle': 'Phase of Lifecycle',
        'Use Phase': 'Use Phase',
        'Commissioning Phase': 'Commissioning Phase',
        'Commissioning Date': 'Commissioning Date',
        'Installation Phase': 'Installation Phase',
        'Device Status': 'Device Status',
        'Basic Information': 'Basic Information',
        'Gateway': 'Gateway',
        'Grid Meter': 'Grid Meter',
        'Load Meter': 'Load Meter',
        'ESS Meter': 'ESS Meter',
        'Total Active Power': 'Total Active Power',
        'Active Power A': 'Active Power A',
        'Active Power B': 'Active Power B',
        'Active Power C': 'Active Power C',
        'Total Reactive Power': 'Total Reactive Power',
        'Reactive Power A': 'Reactive Power A',
        'Reactive Power B': 'Reactive Power B',
        'Reactive Power C': 'Reactive Power C',
        'Total Apparent Power': 'Total Apparent Power',
        'Apparent Power A': 'Apparent Power A',
        'Apparent Power B': 'Apparent Power B',
        'Apparent Power C': 'Apparent Power C',
        'Total Power Factor': 'Total Power Factor',
        'Active Energy Import': 'Active Energy Import',
        'Active Energy Export': 'Active Energy Export',
        'Active Energy Net': 'Active Energy Net',

        'Generator': 'Generator',

        // Photovoltaic Power Station
        'Invertor': 'Invertor',
        'Invertor Run State': 'Invertor Run State',
        'Invertor Unknown': 'Unknown',
        'Invertor Initializing': 'Initializing',
        'Invertor Standby': 'Standby',
        'Invertor Shutdown': 'Shutdown',
        'Invertor Fault': 'Fault',
        'Invertor Running': 'Running',

        //Advanced Reporting & Knowledge base
        'Created Datetime': 'Created Datetime',
        'File Format': 'File Format',
        'File Size': 'File Size',
        Uploader: 'Uploader',
        //Error
        "The page you're looking for is not found": "The page you're looking for is not found",
        "Make sure the address is correct and that the page hasn't moved. ":
            "Make sure the address is correct and that the page hasn't moved. ",
        'If you think this is a mistake,': 'If you think this is a mistake,',
        'contact us': 'contact us',
        'Take me home': 'Take me home',
        'Whoops, something went wrong!': 'Whoops, something went wrong!',
        'Try refreshing the page, or going back and attempting the action again. ':
            'Try refreshing the page, or going back and attempting the action again. ',
        'If this problem persists,': 'If this problem persists,',
        'Captcha Error': 'Captcha Error',
        'Confirm Password Error': 'The confirm password does not match',
        'It looks like you clicked on an invalid password reset link. Please tryagain.':
            'It looks like you clicked \
  on an invalid password reset link. Please tryagain.',
        'It looks like you clicked on an invalid registration account link. Please tryagain.':
            'It looks like you clicked \
  on an invalid registration account link. Please tryagain.',
        //Tenant Bill
        'Lease Contract Number': 'Lease Contract Number',
        Download: 'Download',
        Print: 'Print',
        'Payment Notice': 'Payment Notice',
        'Bill To': 'Bill To',
        'Bill Number': 'Bill Number',
        'Bill Date': 'Bill Date',
        'Payment Due Date': 'Payment Due Date',
        'Amount Payable': 'Amount Payable',
        'Billing Period Start': 'Billing Period Start',
        'Billing Period End': 'Billing Period End',
        Quantity: 'Quantity',
        Price: 'Price',
        Unit: 'Unit',
        Amount: 'Amount',
        Subtotal: 'Subtotal',
        'VAT Output Tax': 'VAT Output Tax',
        'Total Amount Payable': 'Total Amount Payable',
        'Please make sure to pay on or before the payment due date above':
            'Please make sure to pay on or before the payment due date above',
        'Send money to the following account': 'Send money to the following account',
        'Account Name': 'Account Name',
        'Bank Name': 'Bank Name',
        'Bank Address': 'Bank Address',
        'RMB Account': 'RMB Account',
        // button
        'Toggle Navigation': 'Toggle Navigation',
        // working calendar
        'Working Days': 'Working Days',
        'Non Working Days': 'Non Working Days',
        'Select Row': 'Please Select Data Row',
        // Offline Meter Input
        'Daily Value': 'Daily Value',
        Date: 'Date',
        'Successfully Saved': 'Successfully Saved',
        'Previous Data Is Empty': 'Previous Data Is Empty',
        // API
        'API.ACCOUNT_UNLOCK_FAILED': 'Account unlock failed',
        'API.ADMINISTRATOR_SESSION_NOT_FOUND': 'Administrator session not found',
        'API.ADMINISTRATOR_SESSION_TIMEOUT': 'Administrator session timeout',
        'API.ADVANCED_REPORT_NOT_FOUND': 'Advanced report not found',
        'API.API_KEY_HAS_EXPIRED': 'Key has expired',
        'API.API_KEY_NAME_IS_ALREADY_IN_USE': 'Key name is already in use',
        'API.API_KEY_NOT_FOUND': 'Key not found',
        'API.BAD_REQUEST': 'Bad request',
        'API.BALANCING_PRICE_POINT_NOT_FOUND': 'Balancing price point not found',
        'API.BATTERY_STATE_POINT_NOT_FOUND': 'Battery state point not found',
        'API.BUY_METER_NOT_FOUND': 'Buy meter not found',
        'API.CANNOT_SET_EXISTING_SUBMETER_AS_MASTER_METER': 'Cannot set existing submeter as master meter',
        'API.CHARGE_METER_NOT_FOUND': 'Charge meter not found',
        'API.COMBINED_EQUIPMENT_COMMAND_RELATION_EXISTS': 'Combined equipment command relation exists',
        'API.COMBINED_EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Combined equipment command relation not found',
        'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_EXISTS': 'Combined equipment equipment relation exists',
        'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_NOT_FOUND': 'Combined equipment equipment relation not found',
        'API.COMBINED_EQUIPMENT_METER_RELATION_EXISTS': 'Combined equipment meter relation exists',
        'API.COMBINED_EQUIPMENT_METER_RELATION_NOT_FOUND': 'Combined equipment meter relation not found',
        'API.COMBINED_EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Combined equipment name is already in use',
        'API.COMBINED_EQUIPMENT_NOT_FOUND': 'Combined equipment not found',
        'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Combined equipment offline meter relation exists',
        'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Combined equipment offline meter relation not found',
        'API.COMBINED_EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Combined equipment parameter name is already in use',
        'API.COMBINED_EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Combined equipment parameter not found or not match',
        'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Combined equipment virtual meter relation exists',
        'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Combined equipment virtual meter relation not found',
        'API.COMMAND_NAME_IS_ALREADY_IN_USE': 'Command name is already in use',
        'API.COMMAND_NOT_FOUND': 'Command not  found',
        'API.CONTACT_NAME_IS_ALREADY_IN_USE': 'Contact name is already in use',
        'API.CONTACT_NOT_FOUND': 'Contact not found',
        'API.COOLING_METER_NOT_FOUND': 'Cooling meter not found',
        'API.COST_CENTER_EXTERNAL_ID_EXISTS': 'Cost center external id exists',
        'API.COST_CENTER_NAME_EXISTS': 'Cost center name exists',
        'API.COST_CENTER_NOT_FOUND': 'Cost center not found',
        'API.COST_FILE_NOT_FOUND': 'Cost file not found',
        'API.DATA_REPAIR_FILE_NOT_FOUND': 'Data repair file not found',
        'API.DATA_SOURCE_NAME_IS_ALREADY_IN_USE': 'Data source name is already in use',
        'API.DATA_SOURCE_NOT_FOUND': 'Data source not found',
        'API.DATABASE_ERROR': 'Database error',
        'API.DATE_IS_ALREADY_IN_WORKING_CALENDAR': 'Date Is Already In Working Calendar',
        'API.DATE_LOCAL_NOT_FOUND': 'Date local not found',
        'API.DEEPSEEK_INVALID_RESPONSE': 'AI analysis returned an invalid response',
        'API.DEEPSEEK_NOT_CONFIGURED': 'AI analysis is not configured on the server',
        'API.DEEPSEEK_REQUEST_FAILED': 'AI analysis request failed',
        'API.DEEPSEEK_UPSTREAM_ERROR': 'AI analysis service is temporarily unavailable',
        'API.DEEPSEEK_TOO_MANY_MESSAGES': 'Too many messages in this session (maximum is 5)',
        'API.INVALID_MESSAGE_CONTENT': 'Invalid message content',
        'API.INVALID_MESSAGE_ROLE': 'Invalid message role',
        'API.INVALID_MESSAGES': 'Invalid messages',
        'API.INVALID_REPORT_CONTEXT': 'Invalid report context',
        'API.DISCHARGE_METER_NOT_FOUND': 'Discharge meter not found',
        'API.DISTRIBUTION_CIRCUIT_NAME_IS_ALREADY_IN_USE': 'Distribution circuit name is already in use',
        'API.DISTRIBUTION_CIRCUIT_NOT_FOUND': 'Distribution circuit not found',
        'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_EXISTS': 'Distribution circuit point relation exists',
        'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_NOT_FOUND': 'Distribution circuit point relation not found',
        'API.DISTRIBUTION_SYSTEM_NAME_IS_ALREADY_IN_USE': 'Distribution system name is already in use',
        'API.DISTRIBUTION_SYSTEM_NOT_FOUND': 'Distribution system not found',
        'API.ELECTRICITY_METER_NOT_FOUND': 'Electricity meter not found',
        'API.EMAIL_IS_ALREADY_IN_USE': 'Email is already in use',
        'API.EMAIL_MESSAGE_NOT_FOUND': 'Email message not found',
        'API.EMAIL_NOT_FOUND': 'Email not found',
        'API.EMAIL_SERVER_HOST_IS_ALREADY_IN_USE': 'Email server host is already in use',
        'API.EMAIL_SERVER_NOT_FOUND': 'Email server not found',
        'API.EMPTY_VARIABLES_ARRAY': 'Empty variables array',
        'API.ENERGY_CATEGORY_NAME_IS_ALREADY_IN_USE': 'Energy category name is already in use',
        'API.ENERGY_CATEGORY_NOT_FOUND': 'Energy category not found',
        'API.ENERGY_CATEGORY_USED_IN_ENERGY_ITEMS': 'Energy category used in energy items',
        'API.ENERGY_CATEGORY_USED_IN_METER': 'Energy category used in meter',
        'API.ENERGY_CATEGORY_USED_IN_OFFLINE_METER': 'Energy category used in offline meter',
        'API.ENERGY_CATEGORY_USED_IN_TARIFFS': 'Energy category used in tariffs',
        'API.ENERGY_CATEGORY_USED_IN_VIRTUAL_METER': 'Energy category used in virtual meter',
        'API.ENERGY_FLOW_DIAGRAM_LINK_IS_ALREADY_IN_USE': 'Energy flow diagram link is already in use',
        'API.ENERGY_FLOW_DIAGRAM_LINK_NOT_FOUND_OR_NOT_MATCH': 'Energy flow diagram link not found or not match',
        'API.ENERGY_FLOW_DIAGRAM_NAME_IS_ALREADY_IN_USE': 'Energy flow diagram name is already in use',
        'API.ENERGY_FLOW_DIAGRAM_NODE_NAME_IS_ALREADY_IN_USE': 'Energy flow diagram node name is already in use',
        'API.ENERGY_FLOW_DIAGRAM_NODE_NOT_FOUND_OR_NOT_MATCH': 'Energy flow diagram node not found or not match',
        'API.ENERGY_FLOW_DIAGRAM_NOT_FOUND': 'Energy flow diagram not found',
        'API.ENERGY_ITEM_DOES_NOT_BELONG_TO_ENERGY_CATEGORY': 'Energy item does not belong to energy category',
        'API.ENERGY_ITEM_IS_NOT_BELONG_TO_ENERGY_CATEGORY': 'Energy item is not belong to energy category',
        'API.ENERGY_ITEM_NAME_IS_ALREADY_IN_USE': 'Energy item name is already in use',
        'API.ENERGY_ITEM_NOT_FOUND': 'Energy item not found',
        'API.ENERGY_ITEM_USED_IN_METER': 'Energy item used in meter',
        'API.ENERGY_ITEM_USED_IN_OFFLINE_METER': 'Energy item used in offline meter',
        'API.ENERGY_ITEM_USED_IN_VIRTUAL_METER': 'Energy item used in virtual meter',
        'API.ENERGY_STORAGE_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Energy storage power station name is already in use',
        'API.ENERGY_STORAGE_POWER_STATION_NOT_FOUND': 'Energy storage power station not found',
        'API.EQUIPMENT_COMMAND_RELATION_EXISTS': 'Equipment command relation exists',
        'API.EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Equipment command relation not found',
        'API.EQUIPMENT_METER_RELATION_EXISTS': 'Equipment meter relation exists',
        'API.EQUIPMENT_METER_RELATION_NOT_FOUND': 'Equipment meter relation not found',
        'API.EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Equipment name is already in use',
        'API.EQUIPMENT_NOT_FOUND': 'Equipment not found',
        'API.EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Equipment offline meter relation exists',
        'API.EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Equipment offline meter relation not found',
        'API.EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Equipment parameter name is already in use',
        'API.EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Equipment parameter not found or not match',
        'API.EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Equipment virtual meter relation exists',
        'API.EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Equipment virtual meter relation not found',
        'API.ERROR': 'Error',
        'API.EXCEPTION': 'Exception',
        'API.FAILED_TO_READ_REQUEST_STREAM': 'Failed to read request stream',
        'API.FAILED_TO_RESTORE_COST_FILE': 'Failed to restore cost file',
        'API.FAILED_TO_RESTORE_DATA_REPAIR_FILE': 'Failed to restore data repair file',
        'API.FAILED_TO_RESTORE_KNOWLEDGE_FILE': 'Failed to restore knowledge file',
        'API.FAILED_TO_RESTORE_OFFLINE_METER_FILE': 'Failed to restore offline meter file',
        'API.FAILED_TO_SAVE_OFFLINE_METER_FILE': 'Failed to save offline meter file',
        'API.FAILED_TO_UPLOAD_ATTACHMENT_FILE': 'Failed to upload attachment file',
        'API.FAILED_TO_UPLOAD_COST_FILE': 'Failed to upload cost file',
        'API.FAILED_TO_UPLOAD_DATA_REPAIR_FILE': 'Failed to upload data repair file',
        'API.FAILED_TO_UPLOAD_KNOWLEDGE_FILE': 'Failed to upload knowledge file',
        'API.FAILED_TO_UPLOAD_OFFLINE_METER_FILE': 'Failed to upload offline meter file',
        'API.GATEWAY_NAME_IS_ALREADY_IN_USE': 'Gateway name is already in use',
        'API.GATEWAY_NOT_FOUND': 'Gateway not found',
        'API.HEAT_METER_NOT_FOUND': 'Heat meter not found',
        'API.INVALID_': 'Invalid ',
        'API.INVALID_ACKNOWLEDGE_CODE': 'Invalid acknowledge code',
        'API.INVALID_ADDRESS': 'Invalid address',
        'API.INVALID_ADDRESS_VALUE': 'Invalid address value',
        'API.INVALID_ADVANCED_REPORT_ID': 'Invalid advanced report id',
        'API.INVALID_API_KEY_ID': 'Invalid api key id',
        'API.INVALID_API_KEY_NAME': 'Invalid api key name',
        'API.INVALID_AREA_VALUE': 'Invalid area value',
        'API.INVALID_BALANCING_PRICE_POINT_ID': 'Invalid balancing price point ID',
        'API.INVALID_BASE_PERIOD_END_DATETIME': 'Invalid base period end datetime',
        'API.INVALID_BASE_PERIOD_START_DATETIME': 'Invalid base period start datetime',
        'API.INVALID_BATTERY_STATE_POINT_ID': 'Invalid battery state point ID',
        'API.INVALID_BAUD_RATE': 'Invalid baud rate',
        'API.INVALID_BUILDINGS_VALUE': 'Invalid buildings value',
        'API.INVALID_BUY_METER_ID': 'Invalid buy meter id',
        'API.INVALID_CAPACITY': 'Invalid capacity',
        'API.INVALID_CATEGORY': 'Invalid category',
        'API.INVALID_CHANNEL': 'Invalid channel',
        'API.INVALID_CHARGE_METER_ID': 'Invalid charge meter id',
        'API.INVALID_COMBINED_EQUIPMENT_ID': 'Invalid combined equipment id',
        'API.INVALID_COMBINED_EQUIPMENT_NAME': 'Invalid combined equipment name',
        'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_ID': 'Invalid combined equipment parameter id',
        'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_NAME': 'Invalid combined equipment parameter name',
        'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_TYPE': 'Invalid combined equipment parameter type',
        'API.INVALID_COMBINED_EQUIPMENT_UUID': 'Invalid combined equipment uuid',
        'API.INVALID_COMMAND_ID': 'Invalid command id',
        'API.INVALID_COMMAND_NAME': 'Invalid command name',
        'API.INVALID_CONNECTION': 'Invalid connection',
        'API.INVALID_CONSTANT_VALUE': 'Invalid constant value',
        'API.INVALID_CONTACT_ID': 'Invalid contact id',
        'API.INVALID_CONTACT_NAME': 'Invalid contact name',
        'API.INVALID_COOLING_METER_ID': 'Invalid cooling meter id',
        'API.INVALID_COST_CENTER_ID': 'Invalid cost center id',
        'API.INVALID_COST_FILE_ID': 'Invalid cost file id',
        'API.INVALID_CREATED_DATETIME': 'Invalid created datetime',
        'API.INVALID_DATA_REPAIR_FILE_ID': 'Invalid data repair file id',
        'API.INVALID_DATA_SOURCE_ID': 'Invalid data source id',
        'API.INVALID_DATA_SOURCE_NAME': 'Invalid data source name',
        'API.INVALID_DATA_SOURCE_PROTOCOL': 'Invalid data source protocol',
        'API.INVALID_DATE_LOCAL': 'Invalid date local',
        'API.INVALID_DENOMINATOR_METER_UUID': 'Invalid denominator meter uuid',
        'API.INVALID_DISCHARGE_METER_ID': 'Invalid discharge meter id',
        'API.INVALID_DISPLAY_NAME': 'Invalid display name',
        'API.INVALID_DISTRIBUTION_CIRCUIT_ID': 'Invalid distribution circuit id',
        'API.INVALID_DISTRIBUTION_CIRCUIT_NAME': 'Invalid distribution circuit name',
        'API.INVALID_DISTRIBUTION_ROOM': 'Invalid distribution room',
        'API.INVALID_DISTRIBUTION_SYSTEM_ID': 'Invalid distribution system id',
        'API.INVALID_DISTRIBUTION_SYSTEM_NAME': 'Invalid distribution system name',
        'API.INVALID_ELECTRICITY_METER_ID': 'Invalid Electricity meter id',
        'API.INVALID_EMAIL': 'Invalid email',
        'API.INVALID_EMAIL_MESSAGE_ID': 'Invalid email message id',
        'API.INVALID_EMAIL_SERVER_HOST': 'Invalid email server host',
        'API.INVALID_EMAIL_SERVER_ID': 'Invalid email server id',
        'API.INVALID_END_DATE_FORMAT': 'Invalid end date format',
        'API.INVALID_END_DATETIME': 'Invalid end datetime',
        'API.INVALID_ENERGY_CATEGORY_ID': 'Invalid energy category id',
        'API.INVALID_ENERGY_CATEGORY_NAME': 'Invalid energy category name',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_ID': 'Invalid energy flow diagram id',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_LINK_ID': 'Invalid energy flow diagram link id',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_NAME': 'Invalid energy flow diagram name',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_ID': 'Invalid energy flow diagram node id',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_NAME': 'Invalid energy flow diagram node name',
        'API.INVALID_ENERGY_ITEM_ID': 'Invalid energy item id',
        'API.INVALID_ENERGY_ITEM_NAME': 'Invalid energy item name',
        'API.INVALID_ENERGY_STORAGE_POWER_STATION_ID': 'Invalid energy storage power station ID',
        'API.INVALID_ENERGY_STORAGE_POWER_STATION_NAME': 'Invalid energy storage power station name',
        'API.INVALID_EQUATION_IN_EXPRESSION': 'Invalid equation in expression',
        'API.INVALID_EQUIPMENT_ID': 'Invalid equipment id',
        'API.INVALID_EQUIPMENT_NAME': 'Invalid equipment name',
        'API.INVALID_EQUIPMENT_PARAMETER_ID': 'Invalid equipment parameter id',
        'API.INVALID_EQUIPMENT_PARAMETER_NAME': 'Invalid equipment parameter name',
        'API.INVALID_EQUIPMENT_PARAMETER_TYPE': 'Invalid equipment parameter type',
        'API.INVALID_EQUIPMENT_UUID': 'Invalid equipment uuid',
        'API.INVALID_EXPIRES_DATETIME': 'Invalid expires datetime',
        'API.INVALID_EXPRESSION': 'Invalid expression',
        'API.INVALID_EXPRESSION_OBJECT': 'Invalid expression object',
        'API.INVALID_FDD_CODE': 'Invalid fdd code',
        'API.INVALID_FLOORS_VALUE': 'Invalid floors value',
        'API.INVALID_FROM_ADDR': 'Invalid from addr',
        'API.INVALID_GATEWAY_ID': 'Invalid gateway id',
        'API.INVALID_GATEWAY_NAME': 'Invalid gateway name',
        'API.INVALID_HEAT_METER_ID': 'Invalid heat meter id',
        'API.INVALID_HIGH_LIMIT_VALUE': 'Invalid high limit value',
        'API.INVALID_HOURLY_HIGH_LIMIT_VALUE': 'Invalid hourly high limit value',
        'API.INVALID_HOURLY_LOW_LIMIT_VALUE': 'Invalid hourly low limit value',
        'API.INVALID_Id': 'Invalid id',
        'API.INVALID_IS_ADMIN_VALUE': 'Invalid is admin value',
        'API.INVALID_IS_COST_DATA_DISPLAYED': 'Invalid is cost data displayed',
        'API.INVALID_IS_COUNTED_VALUE': 'Invalid is counted value',
        'API.INVALID_IS_ENABLED': 'Invalid is enabled',
        'API.INVALID_IS_HIDDEN': 'Invalid is hidden',
        'API.INVALID_IS_IN_LEASE_VALUE': 'Invalid is in lease value',
        'API.INVALID_IS_INPUT_COUNTED_VALUE': 'Invalid is input counted value',
        'API.INVALID_IS_KEY_TENANT_VALUE': 'Invalid is key tenant value',
        'API.INVALID_IS_OUTPUT_COUNTED_VALUE': 'Invalid is output counted value',
        'API.INVALID_IS_OUTPUT_VALUE': 'Invalid is output value',
        'API.INVALID_IS_READ_ONLY_VALUE': 'Invalid is read only value',
        'API.INVALID_IS_TREND_VALUE': 'Invalid is trend value',
        'API.INVALID_IS_VIRTUAL_VALUE': 'Invalid is virtual value',
        'API.INVALID_KGCE': 'Invalid kgce',
        'API.INVALID_KGCO2E': 'Invalid kgco2e',
        'API.INVALID_KNOWLEDGE_FILE_ID': 'Invalid knowledge file id',
        'API.INVALID_LATITUDE_VALUE': 'Invalid latitude value',
        'API.INVALID_LEASE_NUMBER_VALUE': 'Invalid lease number value',
        'API.INVALID_LONGITUDE_VALUE': 'Invalid longitude value',
        'API.INVALID_LOW_LIMIT_VALUE': 'Invalid low limit value',
        'API.INVALID_MASTER_METER_ID': 'Invalid master meter id',
        'API.INVALID_MENU_ID': 'Invalid menu id',
        'API.INVALID_MESSAGE_DATA': 'Invalid message data',
        'API.INVALID_MESSAGE_TEMPLATE': 'Invalid message template',
        'API.INVALID_MESSAGE_TEMPLATE_ID': 'Invalid message template id',
        'API.INVALID_MESSAGE_VALUE': 'Invalid message value',
        'API.INVALID_METER_ID': 'Invalid meter id',
        'API.INVALID_METER_NAME': 'Invalid meter name',
        'API.INVALID_METER_UUID': 'Invalid meter uuid',
        'API.INVALID_MICROGRID_BATTERY_ID': 'Invalid microgrid battery id',
        'API.INVALID_MICROGRID_BATTERY_NAME': 'Invalid microgrid battery name',
        'API.INVALID_MICROGRID_EVCHARGER_ID': 'Invalid microgrid evcharger id',
        'API.INVALID_MICROGRID_EVCHARGER_NAME': 'Invalid microgrid evcharger name',
        'API.INVALID_MICROGRID_GENERATOR_ID': 'Invalid microgrid generator id',
        'API.INVALID_MICROGRID_GENERATOR_NAME': 'Invalid microgrid generator name',
        'API.INVALID_MICROGRID_GRID_ID': 'Invalid microgrid grid id',
        'API.INVALID_MICROGRID_GRID_NAME': 'Invalid microgrid grid name',
        'API.INVALID_MICROGRID_HEATPUMP_ID': 'Invalid microgrid heatpump id',
        'API.INVALID_MICROGRID_HEATPUMP_NAME': 'Invalid microgrid heatpump name',
        'API.INVALID_MICROGRID_ID': 'Invalid microgrid id',
        'API.INVALID_MICROGRID_LOAD_ID': 'Invalid microgrid load id',
        'API.INVALID_MICROGRID_LOAD_NAME': 'Invalid microgrid load name',
        'API.INVALID_MICROGRID_NAME': 'Invalid microgrid name',
        'API.INVALID_MICROGRID_PHOTOVOLTAIC_ID': 'Invalid microgrid photovoltaic ID',
        'API.INVALID_MICROGRID_PHOTOVOLTAIC_NAME': 'Invalid microgrid photovoltaic name',
        'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_ID': 'Invalid microgrid power conversion system ID',
        'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_NAME': 'Invalid microgrid microgrid power conversion system name',
        'API.INVALID_MICROGRID_UUID': 'Invalid microgrid UUID',
        'API.INVALID_NAME_VALUE': 'Invalid name value',
        'API.INVALID_NEW_PASSWORD': 'Invalid new password',
        'API.INVALID_NON_WORKING_DAY_ID': 'Invalid non working day ID',
        'API.INVALID_NOTIFICATION_ID': 'Invalid notification id',
        'API.INVALID_NUMERATOR_METER_UUID': 'Invalid numerator meter uuid',
        'API.INVALID_OBJECT_TYPE': 'Invalid object type',
        'API.INVALID_OFFLINE_METER_DATA': 'Invalid offline meter data',
        'API.INVALID_OFFLINE_METER_FILE_ID': 'Invalid offline meter file id',
        'API.INVALID_OFFLINE_METER_ID': 'Invalid offline meter id',
        'API.INVALID_OFFLINE_METER_NAME': 'Invalid offline meter name',
        'API.INVALID_OFFLINE_METER_UUID': 'Invalid offline meter uuid',
        'API.INVALID_OFFSET_CONSTANT_VALUE': 'Invalid offset constant value',
        'API.INVALID_OLD_PASSWORD': 'Invalid old password',
        'API.INVALID_OPENID': 'Invalid openid',
        'API.INVALID_PARENT_SPACE_ID': 'Invalid parent space id',
        'API.INVALID_PASSWORD': 'Invalid password',
        'API.INVALID_PAYLOAD': 'Invalid payload',
        'API.INVALID_PEAK_CURRENT': 'Invalid peak current',
        'API.INVALID_PEAK_LOAD': 'Invalid peak load',
        'API.INVALID_PERIOD_TYPE': 'Invalid period type',
        'API.INVALID_PHOTOVOLTAIC_POWER_STATION_ID': 'Invalid photovoltaic power station ID',
        'API.INVALID_PHOTOVOLTAIC_POWER_STATION_NAME': 'Invalid photovoltaic power station name',
        'API.INVALID_POINT_ID': 'Invalid point id',
        'API.INVALID_POINT_NAME': 'Invalid point name',
        'API.INVALID_PORT': 'Invalid port',
        'API.INVALID_POSTAL_CODE_VALUE': 'Invalid postal code value',
        'API.INVALID_POWER_POINT_ID': 'Invalid power point id',
        'API.INVALID_PRIORITY': 'Invalid priority',
        'API.INVALID_PRIVILEGE': 'Invalid privilege',
        'API.INVALID_PRIVILEGE_DATA': 'Invalid privilege data',
        'API.INVALID_PRIVILEGE_ID': 'Invalid privilege id',
        'API.INVALID_PRIVILEGE_NAME': 'Invalid privilege name',
        'API.INVALID_RATIO_VALUE': 'Invalid ratio value',
        'API.INVALID_RECIPIENT_EMAIL': 'Invalid recipient email',
        'API.INVALID_RECIPIENT_MOBILE': 'Invalid recipient mobile',
        'API.INVALID_RECIPIENT_NAME': 'Invalid recipient name',
        'API.INVALID_RECIPIENT_OPENID': 'Invalid recipient openid',
        'API.INVALID_REPLY': 'Invalid reply',
        'API.INVALID_REPORTING_PERIOD_END_DATETIME': 'Invalid reporting period end datetime',
        'API.INVALID_REPORTING_PERIOD_START_DATETIME': 'Invalid reporting period start datetime',
        'API.INVALID_REQUIRES_AUTHENTICATION': 'Invalid requires authentication',
        'API.INVALID_ROOMS_VALUE': 'Invalid rooms value',
        'API.INVALID_RULE_ID': 'Invalid rule id',
        'API.INVALID_RULE_NAME': 'Invalid rule name',
        'API.INVALID_RUN_STATE_POINT_ID': 'Invalid run state point ID',
        'API.INVALID_SCHEDULED_DATETIME': 'Invalid scheduled datetime',
        'API.INVALID_SELL_METER_ID': 'Invalid sell meter id',
        'API.INVALID_SENSOR_ID': 'Invalid sensor id',
        'API.INVALID_SENSOR_NAME': 'Invalid sensor name',
        'API.INVALID_SENSOR_UUID': 'Invalid sensor uuid',
        'API.INVALID_SERIAL_NUMBER': 'Invalid serial number',
        'API.INVALID_SERIAL_PORT': 'Invalid serial port',
        'API.INVALID_SESSION_PLEASE_RE_LOGIN': 'Invalid session please re-login',
        'API.INVALID_SET_VALUE': 'Invalid set value',
        'API.INVALID_SHOPFLOOR_ID': 'Invalid shopfloor id',
        'API.INVALID_SHOPFLOOR_NAME': 'Invalid shopfloor name',
        'API.INVALID_SHOPFLOOR_UUID': 'Invalid shopfloor uuid',
        'API.INVALID_SOURCE_NODE_ID': 'Invalid source node id',
        'API.INVALID_SPACE_ID': 'Invalid space id',
        'API.INVALID_SPACE_NAME': 'Invalid space name',
        'API.INVALID_SPACE_UUID': 'Invalid space uuid',
        'API.INVALID_START_DATE_FORMAT': 'Invalid start date format',
        'API.INVALID_START_DATETIME': 'Invalid start datetime',
        'API.INVALID_STATUS': 'Invalid status',
        'API.INVALID_STORE_ID': 'Invalid store id',
        'API.INVALID_STORE_NAME': 'Invalid store name',
        'API.INVALID_STORE_TYPE_DESCRIPTION': 'Invalid store type description',
        'API.INVALID_STORE_TYPE_ID': 'Invalid store type id',
        'API.INVALID_STORE_TYPE_NAME': 'Invalid store type name',
        'API.INVALID_STORE_TYPE_SIMPLIFIED_CODE': 'Invalid store type simplified code',
        'API.INVALID_STORE_UUID': 'Invalid store uuid',
        'API.INVALID_SUBJECT_VALUE': 'Invalid subject value',
        'API.INVALID_SVG': 'Invalid SVG',
        'API.INVALID_SWITCHGEAR': 'Invalid switchgear',
        'API.INVALID_TARGET_NODE_ID': 'Invalid target node id',
        'API.INVALID_TARIFF_BLOCK_PRICING': 'Invalid tariff block pricing',
        'API.INVALID_TARIFF_ID': 'Invalid tariff id',
        'API.INVALID_TARIFF_TIME_OF_USE_PRICING': 'Invalid tariff time of use pricing',
        'API.INVALID_TARIFF_TYPE': 'Invalid tariff type',
        'API.INVALID_TENANT_ID': 'Invalid tenant id',
        'API.INVALID_TENANT_NAME': 'Invalid tenant name',
        'API.INVALID_TENANT_TYPE_DESCRIPTION': 'Invalid tenant type description',
        'API.INVALID_TENANT_TYPE_ID': 'Invalid tenant type id',
        'API.INVALID_TENANT_TYPE_NAME': 'Invalid tenant type name',
        'API.INVALID_TENANT_TYPE_SIMPLIFIED_CODE': 'Invalid tenant type simplified code',
        'API.INVALID_TENANT_UUID': 'Invalid tenant uuid',
        'API.INVALID_TEXT_MESSAGE_ID': 'Invalid text message id',
        'API.INVALID_TIMEZONE_ID': 'Invalid timezone id',
        'API.INVALID_TOKEN': 'Invalid token',
        'API.INVALID_TOPIC': 'Invalid topic',
        'API.INVALID_UNIT_OF_MEASURE': 'Invalid unit of measure',
        'API.INVALID_UNIT_OF_PRICE': 'Invalid unit of price',
        'API.INVALID_UNITS': 'Invalid units',
        'API.INVALID_USER_ID': 'Invalid user id',
        'API.INVALID_USER_NAME': 'Invalid user name',
        'API.INVALID_USER_NAME_OR_EMAIL': 'Invalid user name or email',
        'API.INVALID_USER_PHONE': 'Invalid user phone',
        'API.INVALID_USER_PLEASE_RE_LOGIN': 'Invalid user please re-login',
        'API.INVALID_USER_UUID': 'Invalid user uuid',
        'API.INVALID_USERNAME': 'Invalid userName',
        'API.INVALID_VARIABLE_METER_ID': 'Invalid variable meter id',
        'API.INVALID_VARIABLE_METER_TYPE': 'Invalid variable meter type',
        'API.INVALID_VARIABLE_NAME': 'Invalid variable name',
        'API.INVALID_VERIFICATION_CODE': 'Invalid verification code',
        'API.INVALID_VIRTUAL_METER_ID': 'Invalid virtual meter id',
        'API.INVALID_VIRTUAL_METER_NAME': 'Invalid virtual meter name',
        'API.INVALID_VIRTUAL_METER_UUID': 'Invalid virtual meter uuid',
        'API.INVALID_WEB_MESSAGE_ID': 'Invalid web message id',
        'API.INVALID_WECHAT_MESSAGE_ID': 'Invalid wechat message id',
        'API.INVALID_WIND_FARM_ID': 'Invalid wind farm ID',
        'API.INVALID_WIND_FARM_NAME': 'Invalid wind farm name',
        'API.INVALID_WORKING_CALENDAR_ID': 'Invalid working calendar id ',
        'API.INVALID_WORKING_CALENDAR_NAME': 'Invalid working calendar name',
        'API.KNOWLEDGE_FILE_CANNOT_BE_REMOVED_FROM_DISK': 'Knowledge File Cannot be Removed from Disk',
        'API.KNOWLEDGE_FILE_NOT_FOUND': 'Knowledge file not found',
        'API.MASTER_METER_DOES_NOT_BELONG_TO_SAME_ENERGY_CATEGORY':
            'Master meter does not belong to same energy category',
        'API.MASTER_METER_NOT_FOUND': 'Master meter not found',
        'API.MENU_NOT_FOUND': 'Menu not found',
        'API.METER_CANNOT_HAVE_MORE_THAN_ONE_ENERGY_VALUE_POINTS': 'Meter cannot have more than one energy value points',
        'API.METER_COMMAND_RELATION_EXISTS': 'Meter command relation exists',
        'API.METER_COMMAND_RELATION_NOT_FOUND': 'Meter command relation not found',
        'API.METER_NAME_IS_ALREADY_IN_USE': 'Meter name is already in use',
        'API.METER_NOT_FOUND': 'Meter not found',
        'API.METER_OF_VARIABLE_NOT_FOUND': 'Meter of variable not found',
        'API.METER_POINT_RELATION_EXISTS': 'Meter point relation exists',
        'API.METER_POINT_RELATION_NOT_FOUND': 'Meter point relation not found',
        'API.MICROGRID_BATTERY_NAME_IS_ALREADY_IN_USE': 'Microgrid battery name is already in use',
        'API.MICROGRID_BATTERY_NOT_FOUND': 'Microgrid battery not found',
        'API.MICROGRID_EVCHARGER_NAME_IS_ALREADY_IN_USE': 'Microgrid evcharger name is already in use',
        'API.MICROGRID_EVCHARGER_NOT_FOUND': 'Microgrid evcharger not fund',
        'API.MICROGRID_GENERATOR_NAME_IS_ALREADY_IN_USE': 'Microgrid generator name is already in use',
        'API.MICROGRID_GENERATOR_NOT_FOUND': 'Microgrid generator not found',
        'API.MICROGRID_GRID_NAME_IS_ALREADY_IN_USE': 'Microgrid grid name is already in use',
        'API.MICROGRID_GRID_NOT_FOUND': 'Microgrid grid not found',
        'API.MICROGRID_HEATPUMP_NAME_IS_ALREADY_IN_USE': 'Microgrid heatpump name is already in use',
        'API.MICROGRID_HEATPUMP_NOT_FOUND': 'Microgrid heatpump not found',
        'API.MICROGRID_LOAD_NAME_IS_ALREADY_IN_USE': 'Microgrid load name is already',
        'API.MICROGRID_LOAD_NOT_FOUND': 'Microgrid load not found',
        'API.MICROGRID_NAME_IS_ALREADY_IN_USE': 'Microgrid name is already in use',
        'API.MICROGRID_NOT_FOUND': 'Microgrid not found',
        'API.MICROGRID_PHOTOVOLTAIC_NAME_IS_ALREADY_IN_USE': 'Microgrid photovoltaic name is already in use',
        'API.MICROGRID_PHOTOVOLTAIC_NOT_FOUND': 'Microgrid photovoltaic not found',
        'API.MICROGRID_POWER_CONVERSION_SYSTEM_NAME_IS_ALREADY_IN_USE':
            'Microgrid power conversion system name is already in use',
        'API.MICROGRID_POWER_CONVERSION_SYSTEM_NOT_FOUND': 'Microgrid power conversion system not found',
        'API.MICROGRID_SENSOR_RELATION_EXISTS': 'Microgrid sensor relation exists',
        'API.MICROGRID_SENSOR_RELATION_NOT_FOUND': 'Microgrid sensor not found',
        'API.MQTT_CONNECTION_ERROR': 'Mqtt connection error',
        'API.MQTT_PUBLISH_ERROR': 'Mqtt publish error',
        'API.NEW_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'New password length cannot exceed 100 characters',
        'API.NEW_USER_SESSION_NOT_FOUND': 'New user session not found',
        'API.NEW_USER_SESSION_TIMEOUT': 'New user session timeout',
        'API.NON_WORKING_DAY_NOT_FOUND': 'Non working day non found',
        'API.NOT_FOUND': 'Not found',
        'API.NOTIFICATION_NOT_FOUND': 'Notification not found',
        'API.OFFLINE_METER_FILE_NOT_FOUND': 'Offline meter file not found',
        'API.OFFLINE_METER_NAME_IS_ALREADY_IN_USE': 'Offline meter name is already in use',
        'API.OFFLINE_METER_NOT_FOUND': 'Offline meter not found',
        'API.INVALID_OFFLINE_METER_VALUE': 'Invalid offline meter value',
        'API.OFFLINE_METER_OF_VARIABLE_NOT_FOUND': 'Offline meter of variable not found',
        'API.OLD_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Old password length cannot exceed 100 characters',
        'API.PARENT_SPACE_NOT_FOUND': 'Parent space not found',
        'API.PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Password length cannot exceed 100 characters',
        'API.PASSWORDS_MATCH': 'New password is the same as the old password',
        'API.PHOTOVOLTAIC_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Photovoltaic power station name is already in use',
        'API.PHOTOVOLTAIC_POWER_STATION_NOT_FOUND': 'Photovoltaic power station not found',
        'API.POINT_NAME_IS_ALREADY_IN_USE': 'Point name is already in use',
        'API.POINT_NOT_FOUND': 'Point not found',
        'API.POWER_POINT_NOT_FOUND': 'Power point not found',
        'API.PRIVILEGE_NAME_IS_ALREADY_IN_USE': 'Privilege name is already in use',
        'API.PRIVILEGE_NOT_FOUND': 'Privilege not found',
        'API.RULE_NAME_IS_ALREADY_IN_USE': 'Rule name is already in use',
        'API.RULE_NOT_FOUND': 'Rule not found',
        'API.SELL_METER_NOT_FOUND': 'Sell meter not found',
        'API.SENSOR_NAME_IS_ALREADY_IN_USE': 'Sensor name is already in use',
        'API.SENSOR_NOT_FOUND': 'Sensor not found',
        'API.SENSOR_POINT_RELATION_EXISTS': 'Sensor point relation exists',
        'API.SENSOR_POINT_RELATION_NOT_FOUND': 'Sensor point relation not found',
        'API.SHOPFLOOR_COMMAND_RELATION_EXISTS': 'Shopfloor command relation exists',
        'API.SHOPFLOOR_COMMAND_RELATION_NOT_FOUND': 'Shopfloor command relation not found',
        'API.SHOPFLOOR_EQUIPMENT_RELATION_EXISTS': 'Shopfloor equipment relation exists',
        'API.SHOPFLOOR_EQUIPMENT_RELATION_NOT_FOUND': 'Shopfloor equipment relation not found',
        'API.SHOPFLOOR_METER_RELATION_EXISTS': 'Shopfloor meter relation exists',
        'API.SHOPFLOOR_METER_RELATION_NOT_FOUND': 'Shopfloor meter relation not found',
        'API.SHOPFLOOR_NAME_IS_ALREADY_IN_USE': 'Shopfloor name is already in use',
        'API.SHOPFLOOR_NOT_FOUND': 'Shopfloor not found',
        'API.SHOPFLOOR_OFFLINE_METER_RELATION_EXISTS': 'Shopfloor offline meter relation exists',
        'API.SHOPFLOOR_OFFLINE_METER_RELATION_NOT_FOUND': 'Shopfloor offline meter relation not found',
        'API.SHOPFLOOR_POINT_RELATION_EXISTS': 'Shopfloor point relation exists',
        'API.SHOPFLOOR_POINT_RELATION_NOT_FOUND': 'Shopfloor point relation not found',
        'API.SHOPFLOOR_SENSOR_RELATION_EXISTS': 'Shopfloor sensor relation exists',
        'API.SHOPFLOOR_SENSOR_RELATION_NOT_FOUND': 'Shopfloor sensor relation not found',
        'API.SHOPFLOOR_VIRTUAL_METER_RELATION_EXISTS': 'Shopfloor virtual meter relation exists',
        'API.SHOPFLOOR_VIRTUAL_METER_RELATION_NOT_FOUND': 'Shopfloor virtual meter relation not found',
        'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_EXISTS': 'Shopfloor working calendar relation exists',
        'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Shopfloor working calendar relation not found',
        'API.SOC_POINT_NOT_FOUND': 'SOC point not found',
        'API.SOURCE_NODE_NOT_FOUND': 'Source node not found',
        'API.SPACE_COMBINED_EQUIPMENT_RELATION_EXISTS': 'Space combined equipment relation exists',
        'API.SPACE_COMBINED_EQUIPMENT_RELATION_NOT_FOUND': 'Space combined equipment relation not found',
        'API.SPACE_COMMAND_RELATION_EXISTS': 'Space command relation exists',
        'API.SPACE_COMMAND_RELATION_NOT_FOUND': 'Space command relation not found',
        'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_EXISTS': 'Space Energy Storage Power Station Relation Exists',
        'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_NOT_FOUND': 'Space Energy Storage Power Station Relation Not Found',
        'API.SPACE_EQUIPMENT_RELATION_EXISTS': 'Space equipment relation exists',
        'API.SPACE_EQUIPMENT_RELATION_NOT_FOUND': 'Space equipment relation not found',
        'API.SPACE_METER_RELATION_EXISTS': 'Space meter relation exists',
        'API.SPACE_METER_RELATION_NOT_FOUND': 'Space meter relation not found',
        'API.SPACE_NAME_IS_ALREADY_IN_USE': 'Space name is already in use',
        'API.SPACE_NOT_FOUND': 'Space not found',
        'API.SPACE_NOT_FOUND_IN_PRIVILEGE': 'Space not found in privilege',
        'API.SPACE_OFFLINE_METER_RELATION_EXISTS': 'Space offline meter relation exists',
        'API.SPACE_OFFLINE_METER_RELATION_NOT_FOUND': 'Space offline meter relation not found',
        'API.SPACE_POINT_RELATION_EXISTS': 'Space point relation exists',
        'API.SPACE_POINT_RELATION_NOT_FOUND': 'Space point relation not found',
        'API.SPACE_SENSOR_RELATION_EXISTS': 'Space sensor relation exists',
        'API.SPACE_SENSOR_RELATION_NOT_FOUND': 'Space sensor relation not found',
        'API.SPACE_SHOPFLOOR_RELATION_EXISTS': 'Space shopfloor relation exists',
        'API.SPACE_SHOPFLOOR_RELATION_NOT_FOUND': 'Space shopfloor relation not found',
        'API.SPACE_STORE_RELATION_EXISTS': 'Space store relation exists',
        'API.SPACE_STORE_RELATION_NOT_FOUND': 'Space store relation not found',
        'API.SPACE_TENANT_RELATION_EXISTS': 'Space tenant relation exists',
        'API.SPACE_TENANT_RELATION_NOT_FOUND': 'Space tenant relation not found',
        'API.SPACE_VIRTUAL_METER_RELATION_EXISTS': 'Space virtual meter relation exists',
        'API.SPACE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Space virtual meter relation not found',
        'API.SPACE_WORKING_CALENDAR_RELATION_EXISTS': 'Space working calendar relation exists',
        'API.SPACE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Space working calendar relation not found',
        'API.START_DATETIME_MUST_BE_EARLIER_THAN_END_DATETIME': 'Start datetime must be early than end datetime',
        'API.STORE_COMMAND_RELATION_EXISTS': 'Store command relation exists',
        'API.STORE_COMMAND_RELATION_NOT_FOUND': 'Store command relation not found',
        'API.STORE_METER_RELATION_EXISTS': 'Store meter relation exists',
        'API.STORE_METER_RELATION_NOT_FOUND': 'Store meter relation not found',
        'API.STORE_NAME_IS_ALREADY_IN_USE': 'Store name is already in use',
        'API.STORE_NOT_FOUND': 'Store not found',
        'API.STORE_OFFLINE_METER_RELATION_EXISTS': 'Store offline meter relation exists',
        'API.STORE_OFFLINE_METER_RELATION_NOT_FOUND': 'Store offline meter relation not found',
        'API.STORE_POINT_RELATION_EXISTS': 'Store point relation exists',
        'API.STORE_POINT_RELATION_NOT_FOUND': 'Store point relation not found',
        'API.STORE_SENSOR_RELATION_EXISTS': 'Store sensor relation exists',
        'API.STORE_SENSOR_RELATION_NOT_FOUND': 'Store sensor relation not found',
        'API.STORE_TYPE_NAME_IS_ALREADY_IN_USE': 'Store type name is already in use',
        'API.STORE_TYPE_NOT_FOUND': 'Store type not found',
        'API.STORE_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Store type simplified code is already in use',
        'API.STORE_TYPE_USED_IN_STORE': 'Store type used in store',
        'API.STORE_VIRTUAL_METER_RELATION_EXISTS': 'Store virtual meter relation exists',
        'API.STORE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Store virtual meter relation not found',
        'API.STORE_WORKING_CALENDAR_RELATION_EXISTS': 'Store working calendar relation exists',
        'API.STORE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Store working calendar relation not found',
        'API.TARGET_NODE_NOT_FOUND': 'Target node not found',
        'API.TARIFF_IN_USE': 'Tariff in use',
        'API.TARIFF_IS_ALREADY_ASSOCIATED_WITH_COST_CENTER': 'Tariff is already associated with cost center',
        'API.TARIFF_IS_NOT_ASSOCIATED_WITH_COST_CENTER': 'Tariff is not associated with cost center',
        'API.TARIFF_NAME_IS_ALREADY_IN_USE': 'Tariff name is already in use',
        'API.TARIFF_NOT_FOUND': 'Tariff not found',
        'API.TENANT_COMMAND_RELATION_EXISTS': 'Tenant command relation exists',
        'API.TENANT_COMMAND_RELATION_NOT_FOUND': 'Tenant command relation  not found',
        'API.TENANT_METER_RELATION_EXISTS': 'Tenant meter relation exists',
        'API.TENANT_METER_RELATION_NOT_FOUND': 'Tenant meter relation not found',
        'API.TENANT_NAME_IS_ALREADY_IN_USE': 'Tenant name is already in use',
        'API.TENANT_NOT_FOUND': 'Tenant not found',
        'API.TENANT_OFFLINE_METER_RELATION_EXISTS': 'Tenant offline meter relation exists',
        'API.TENANT_OFFLINE_METER_RELATION_NOT_FOUND': 'Tenant offline meter relation not found',
        'API.TENANT_POINT_RELATION_EXISTS': 'Tenant point relation exists',
        'API.TENANT_POINT_RELATION_NOT_FOUND': 'Tenant point relation not found',
        'API.TENANT_SENSOR_RELATION_EXISTS': 'Tenant sensor relation exists',
        'API.TENANT_SENSOR_RELATION_NOT_FOUND': 'Tenant sensor relation not found',
        'API.TENANT_TYPE_NAME_IS_ALREADY_IN_USE': 'Tenant type name is already in use',
        'API.TENANT_TYPE_NOT_FOUND': 'Tenant type not found',
        'API.TENANT_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Tenant type simplified code is already in use',
        'API.TENANT_TYPE_USED_IN_TENANT': 'Tenant type used in tenant',
        'API.TENANT_VIRTUAL_METER_RELATION_EXISTS': 'Tenant virtual meter relation exists',
        'API.TENANT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Tenant virtual meter relation not found',
        'API.TENANT_WORKING_CALENDAR_RELATION_EXISTS': 'Tenant working calendar relation exists',
        'API.TENANT_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Tenant working calendar relation not found',
        'API.TEXT_MESSAGE_NOT_FOUND': 'Text message not found',
        'API.THE_REPORTING_PERIOD_MUST_BE_LONGER_THAN_15_MINUTES': 'The reporting period must be longer than 15 minutes',
        'API.THERE_IS_RELATION_WITH_CHILD_METERS': 'There is relation with child meters',
        'API.THERE_IS_RELATION_WITH_CHILDREN_SPACES': 'There is relation with children spaces',
        'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENT_PARAMETERS':
            'There is relation with combined equipment parameters',
        'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENTS': 'There is relation with combined equipments',
        'API.THERE_IS_RELATION_WITH_DATA_SOURCES': 'There is relation with data sources',
        'API.THERE_IS_RELATION_WITH_ENERGY_FLOW_DIAGRAM_LINKS': 'There is relation with energy flow diagram links',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_BATTERIES': 'There Is Relation With Energy Storage Containers Batteries',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_GRIDS': 'There Is Relation With Energy Storage Containers Grids',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_LOADS': 'There Is Relation With Energy Storage Containers Loads',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_POWER_CONVERSION_SYSTEMS': 'There Is Relation With Energy Storage Containers Power Conversion Systems',
        'API.THERE_IS_RELATION_WITH_EQUIPMENT_PARAMETERS': 'There is relation with equipment parameters',
        'API.THERE_IS_RELATION_WITH_EQUIPMENTS': 'There is relation with equipments',
        'API.THERE_IS_RELATION_WITH_METER': 'There is relation with meter',
        'API.THERE_IS_RELATION_WITH_METERS': 'There is relation with meters',
        'API.THERE_IS_RELATION_WITH_OFFLINE_METER': 'There is relation with offline meter',
        'API.THERE_IS_RELATION_WITH_OFFLINE_METERS': 'There is relation with offline meters',
        'API.THERE_IS_RELATION_WITH_OTHER_VIRTUAL_METERS': 'There is relation with other virtual meters',
        'API.THERE_IS_RELATION_WITH_SENSORS': 'There is relation with sensors',
        'API.THERE_IS_RELATION_WITH_SHOPFLOORS': 'There is relation with shopfloors',
        'API.THERE_IS_RELATION_WITH_SPACES': 'There is relation with spaces',
        'API.THERE_IS_RELATION_WITH_STORES': 'There is relation with stores',
        'API.THERE_IS_RELATION_WITH_TENANTS': 'There is relation with tenants',
        'API.THERE_IS_RELATION_WITH_USERS': 'There is relation with users',
        'API.THERE_IS_RELATION_WITH_VIRTUAL_METER': 'There is relation with virtual meter',
        'API.THERE_IS_RELATION_WITH_VIRTUAL_POWER_PLANTS': 'There is relation with virtual power plants',
        'API.THIS_DATA_SOURCE_IS_BEING_USED_BY_A_METER': 'This data source is being used by a meter',
        'API.THIS_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'This meter is being used by a virtual meter',
        'API.THIS_OFFLINE_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'This offline meter is being used by a virtual meter',
        'API.THIS_SPACE_CANNOT_BE_CLONED': 'This space cannot be cloned',
        'API.THIS_SPACE_CANNOT_BE_DELETED': 'This space cannot be deleted',
        'API.TIMEZONE_NOT_FOUND': 'Timezone not found',
        'API.TOKEN_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'Token not found in headers please login',
        'API.USER_ACCOUNT_HAS_BEEN_LOCKED': 'User Account Has Been Locked',
        'API.USER_ACCOUNT_HAS_EXPIRED': 'User Account Has Expired',
        'API.USER_ACCOUNT_IS_NOT_LOCKED': 'User account is not locked',
        'API.USER_NAME_IS_ALREADY_IN_USE': 'User name is already in use',
        'API.USER_NOT_FOUND': 'User not found',
        'API.USER_PASSWORD_HAS_EXPIRED': 'User Password Has Expired',
        'API.USER_PRIVILEGE_NOT_FOUND': 'User privilege not found',
        'API.USER_SESSION_NOT_FOUND': 'User session not found',
        'API.USER_SESSION_TIMEOUT': 'User session timeout',
        'API.USER_UUID_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'User uuid not found in headers please login',
        'API.VIRTUAL_METER_NAME_IS_ALREADY_IN_USE': 'Virtual meter name is already in use',
        'API.VIRTUAL_METER_NOT_FOUND': 'Virtual meter not found',
        'API.VIRTUAL_METER_OF_VARIABLE_NOT_FOUND': 'Virtual meter of variable not found',
        'API.VIRTUAL_POINT_SHOULD_BE_ANALOG_VALUE': 'Virtual point should be analog value',
        'API.WEB_MESSAGE_NOT_FOUND': 'Web message not found',
        'API.WECHAT_MESSAGE_NOT_FOUND': 'Wechat message not found',
        'API.WIND_FARM_NAME_IS_ALREADY_IN_USE': 'Wind farm name is already in use',
        'API.WIND_FARM_NOT_FOUND': 'Wind farm not found',
        'API.WORKING_CALENDAR_NAME_IS_ALREADY_IN_USE': 'Working calendar name is already in use',
        'API.WORKING_CALENDAR_NOT_FOUND': 'Working calendar not found',

        MasterMeter: 'Master Meter',
        SubMeter: 'Submeter',
        'Power Quality': 'Netzqualität',
        'About Power Quality': 'Über die Netzqualität',
        Category: 'Kategorie',
        Type: 'Typ',
        Limit: 'Grenzwert',
        'Normal Limit': 'Normaler Grenzwert',
        'Severe Limit': 'Schwerer Grenzwert',
        Compliance: 'Einhaltungsrate',
        'Worst Deviation': 'Schlimmste Abweichung',
        'Worst Time': 'Schlimmster Zeitpunkt',
        'Severe Exceed Count': 'Anzahl schwerer Überschreitungen',
        'Worst Unbalance': 'Größte Unwucht',
        Hz: 'Hz',
        voltage: 'Voltage',
        current: 'Current',
        frequency: 'Frequency',
        voltage_deviation: 'Voltage Deviation',
        current_unbalance: 'Current Unbalance',
        voltage_unbalance: 'Voltage Unbalance',
        mean_deviation_pct: 'Mean Deviation (%)',
        p95_abs_deviation_pct: 'P95 Abs Deviation (%)',
        mean_abs_deviation_hz: 'Mean Abs Deviation (Hz)',
        frequency_deviation: 'Frequency Deviation',
        p95_abs_deviation_hz: 'P95 Abs Deviation (Hz)',
        mean_unbalance_pct: 'Mean Unbalance (%)',
        p95_unbalance_pct: 'P95 Unbalance (%)',
        count: 'Count',
        min: 'Min',
        max: 'Max',
        mean: 'Mean',
        std: 'Std',
        p5: 'P5',
        p95: 'P95'
    }
};
